import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Big3DatePicker, NoResult, GoodsPhoto, Alert } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:소매 주문별 문의 리스트
 * 세부설명:
*/

export class RtiQstList extends Component {
    static displayName = RtiQstList.name;
    constructor(props) {
        super(props);
        this.CsName = Big3Common.ContentState;
        
        this.fromDate = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.FromDate,
            format(Big3Common.Util.DateAdd(new Date(), -29), "yyyy-MM-dd")
        );

        this.toDate = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.ToDate,
            format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd")
        );

        this.SelectMonth = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SelectMonth,1);
        this.Union_Uid = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Union_Uid, "");
      

        this.state = {
            QstMgtlList:[],
            FromDate: this.fromDate,
            ToDate: this.toDate,
            SelectMonth: this.SelectMonth,
            Content: ""
        };
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleMonth_Click = this.handleMonth_Click.bind(this);
        this.handleRtiQstDtl_Click = this.handleRtiQstDtl_Click.bind(this);
    }
    //초기화
    async componentDidMount() {
        await this.CallQstMgtDtlListData();
    }
    //주문목록 조회
    async CallQstMgtDtlListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstMgtDtlList',
                {
                    "Union_Uid": this.Union_Uid,
                    "FromDate": this.state.FromDate,
                    "ToDate": this.state.ToDate
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);                
                this.setState({ QstMgtlList: DataList });
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallQstMgtDtlListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
   //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
    }
    //월별 버튼 클릭
    handleMonth_Click(event, Month) {
        let fromDate = format(Big3Common.Util.DateAdd(new Date(this.state.ToDate), -(Month * 30)), "yyyy-MM-dd");
        this.setState({ SelectMonth: Month, FromDate: fromDate });
        event.preventDefault();
    }
    handleRtiQstDtl_Click(event, list) {
        if (this.props.ContentState === undefined) {
            return false;
        }
        const ContentState = this.props.ContentState;
        this.props.RenderComponent("RtiQstDtl", {
            [this.CsName.Union_Uid]: list.union_uid,
            [this.CsName.QstgrpNo]: list.qstgrp_no,
            [this.CsName.SelectMonth]: this.state.SelectMonth,
            [this.CsName.FromDate]: this.state.FromDate,
            [this.CsName.ToDate]: this.state.ToDate,
            [this.CsName.Whole_Name]: Big3Common.Util.GetContentState(ContentState, this.CsName.Whole_Name, ""),
            [this.CsName.SearchText]: Big3Common.Util.GetContentState(ContentState, this.CsName.SearchText, "")
        });
        event.preventDefault();
    }
    QstMgtreder() {
        const QstMgtlList = this.state.QstMgtlList;
        return (
            <>
                {
                    QstMgtlList.map(list =>
                        <div className="alert_content" key={list.qstgrp_no} onClick={(e) => { this.handleRtiQstDtl_Click(e,list); } }>
                            <div className="alert_img">
                                <GoodsPhoto className="alert_img_in"
                                    ImageSrc={list.img_220}
                                />
                            </div>
                            <div className="alert_txt">
                                <div className="order_date od1">문의일자 : {list.reg_dt}</div>
                                <div className="order_date od2">문의번호:  {list.qstgrp_no}</div>
                                <div className="product_name">품목: {list.goods_names || ""}</div>
                                <div className="product_name">금액: {Big3Common.Util.Money(list.goods_price)}원</div>
                                <div className="or_s_btn">{list.qstmgt_status_nm}</div>
                                <div className="c_icon_box">
                                    {list.conf_count > 0 ? <div className="Q_icon"></div> : ""}
                                    {list.comment_count > 0 ? <div className="C_icon"></div> : ""}
                                </div>
                            </div>
                        </div>
                    )
                }
            </>
        )
    }
    render() {
        const QstMgtreder = this.QstMgtreder();
        return (
            <div className="container_box2 p_margin u_padding history_box">
                <div className="search_box">
                    <div className="select_month_box">
                        <div className={this.state.SelectMonth === 1 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 1) }}>1개월</div>
                        <div className={this.state.SelectMonth === 3 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 3) }}>3개월</div>
                        <div className={this.state.SelectMonth === 6 ? "month select pointer" : "month pointer"} onClick={(e) => { this.handleMonth_Click(e, 6) }}>6개월</div>
                    </div>
                    <div className="select_date_box">
                        <div className="select_date_box_input">
                           <Big3DatePicker
                                    className="form-control"
                                    setDate={new Date(this.state.FromDate)}
                                    DateChange={this.handleCalendarChange}
                                    id="FromDate"
                                />
                        </div>
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                    className="form-control"
                                    setDate={new Date(this.state.ToDate)}
                                    DateChange={this.handleCalendarChange}
                                    id="ToDate"
                                />
                        </div>
                        <button type="button" className="date_s_btn" onClick={(e) => { this.CallQstMgtDtlListData(); e.preventDefault(); }}>조회</button>
                    </div>
                </div>
                {QstMgtreder}
                <NoResult
                    Visible={this.state.QstMgtlList.length === 0 ? true : false}
                    Top={"60%"}
                />
                <Alert
                    title="검색안내"
                    id="MessageAlert"
                    content={this.state.Content}
                />
             </div>
        );
    }
}
